import React from 'react';
import '../../styles/About.css';

const About: React.FC = () => {
  return (
    <div className="about-container">
      <h1>About Us</h1>
      <p>Hey there, fellow gamer! Welcome to Codenerdette Gaming Hub, where the vibes are chill, and the games are lit. 🎮✨</p>
      <p>Meet "AI-Powered Ancestor’s Legacy" - a game where you're not just playing; you're vibing as a spirit guide from the past. Your mission? Guide your descendant through epic challenges, solve mind-bending mysteries, and maybe even change history. Your choices? They shape the fate of your legacy. No pressure, right? 😅</p>
      <p>Our dev? A solo legend using free tools, crafting this masterpiece just for the fun of it. So, grab your snacks, get comfy, and dive into the adventure. Let's make some history! 🚀</p>
    </div>
  );
};

export default About; 